import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Dialog from "components/Dialog";
import useStyles from "./styles";

export interface Props {
  open: boolean;
  horseName: string;
  onClose: () => void;
}

const WorkoutRequiredDialog = (props: Props) => {
  const { open, horseName, onClose } = props;
  const classes = useStyles();

  return (
    <Dialog
      title={"Workout required"}
      alert
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      className={classes.horseAlertDialog}
      isOpen={open}
    >
      <Box>
        <Typography className={classes.horseAlertDialogMessage}>
          <b>{horseName}</b> requires a workout for the following reasons:
        </Typography>
        <Divider />
        <Box className={classes.horseAlertDialogReasons}>
          <Box className={classes.alertReason}>
            <Typography className={classes.alertReasonText}>
              1. On List
            </Typography>
            <Box className={classes.horseAlertDialogReasonButton}>Vet List</Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default WorkoutRequiredDialog;
